// src/pages/Reports.js
import React from 'react';
import styles from './Reports.module.css';

import DashboardMetrics from '../reports/DashboardMetrics';
import DriverPerformance from '../reports/DriverPerformance';
import ShowroomStats from '../reports/ShowroomStats';
import CollectionsSummary from '../reports/CollectionsSummary';
import OrdersDelayList from '../reports/OrdersDelayList';
import MetricsGraph from '../reports/MetricsGraph';

export default function Reports() {
  const [range, setRange] = React.useState('today');

  // THEME STATE
  const [theme, setTheme] = React.useState(
    localStorage.getItem('theme') || 'light'
  );

  React.useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <div className={styles.reportsContainer}>
      
      {/* ========================== HEADER ========================== */}
      <div className={styles.header}>
        
        {/* LEFT: TITLE */}
        <div className={styles.leftArea}>
          <h1 className={styles.title}>Reports</h1>
          <p className={styles.subtitle}>Overview of orders, deliveries and revenue</p>
        </div>

        {/* RIGHT: SELECT + THEME TOGGLE */}
        <div className={styles.rightControls}>
          
          {/* Premium Select */}
          <div className={styles.selectWrapper}>
            <select
              value={range}
              onChange={(e) => setRange(e.target.value)}
              className={styles.premiumSelect}
            >
              <option value="today">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="mtd">MTD</option>
              <option value="ytd">YTD</option>
              <option value="last90">Last 90 Days</option>
              <option value="last180">Last 180 Days</option>
            </select>
          </div>

          {/* Clean theme toggle (black & white icons) */}
          <button
            className={styles.themeToggle}
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          >
            {theme === 'dark' ? (
              <span style={{ fontSize: '18px', color: '#faf9f9ff' }}>☀</span>
            ) : (
              <span style={{ fontSize: '18px', color: '#090909ff' }}>☾</span>
            )}
          </button>

        </div>
      </div>
      {/* ============================================================= */}

      
      {/* TOP METRICS */}
      <DashboardMetrics range={range} />

      {/* DRIVER + SHOWROOM */}
      <div className={styles.statsGrid}>
        <DriverPerformance range={range} />
        <ShowroomStats range={range} />
      </div>

      {/* ORDERS DELAY */}
      <OrdersDelayList range={range} />

      {/* COLLECTIONS SUMMARY */}
      <CollectionsSummary range={range} />

      {/* TRENDS GRAPH */}
      <MetricsGraph range={range} />

    </div>
  );
}
